export const VAILD_BRANDS = ['AT', 'KBB'];
let brand;
export const getBrand = refresh => {
  if (refresh || !brand) {
    const queryBrand = new URLSearchParams(globalThis.location.search).get('brand')?.toUpperCase();
    if (VAILD_BRANDS.includes(queryBrand)) {
      brand = queryBrand;
    } else {
      brand = globalThis.location.hostname?.endsWith('kbb.com') ? 'KBB' : 'AT';
    }
  }
  return brand;
};